
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/7ways-to-improve-memory",
      function () {
        return require("private-next-pages/7ways-to-improve-memory/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/7ways-to-improve-memory"])
      });
    }
  